import React, { useContext, useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import useMenuPermissions from "../../components/CustomHook/custompermission";
import Notauthorized from "../../components/Not-authorized/notauthorized";
import APIServicenew from "../../utils/APIGeneralService";
import { UserContext } from "../../context/UserContextProvider";
import MomListFilter from "./MomListFilter";
import {
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  addDays,
  format,
  isSameDay,
  isSameMonth,
  parseISO,
} from 'date-fns';
import '../../assets/css/Calendar.css';


const Calendar = () => {
  const [activeTab, setActiveTab] = useState("listView");
  const permissionscontext = useMenuPermissions("/admin/mom-list");
  const [currentPage, setCurrentPage] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [filters, setFilters] = useState({});
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = { "auth-token": authToken, authorization: accessToken };
  const limit = 10;
  const navigate = useNavigate();

  const [currentMonth, setCurrentMonth] = useState(new Date());

  const events = [
    {
      date: parseISO('2025-03-10'),
      eventName: 'Project Meeting',
    },
    {
      date: parseISO('2025-04-10'),
      eventName: 'Project Meeting',
    },
    {
      date: parseISO('2025-04-10'),
      eventName: 'Project Meeting',
    },
    {
      date: parseISO('2025-03-15'),
      eventName: 'Birthday Party',
    },
    {
      date: parseISO('2025-03-22'),
      eventName: 'Presentation',
    },
    {
      date: parseISO('2025-03-01'),
      eventName: 'Start of the month',
    },
    {
      date: parseISO('2025-03-31'),
      eventName: 'End of the month',
    },
    {
      date: parseISO('2025-03-10'),
      eventName: 'Team Lunch', // Multiple events on the same day
    },
    {
      date: parseISO('2025-03-15'),
      eventName: 'Game night' //Multiple events on the same day
    }
  ];
  console.log("events",events)

  const renderHeader = () => {
    const dateFormat = 'MMMM';
    return (
      <div className="header row flex-middle">
        <div className="col col-start">
          <div className="icon" onClick={prevMonth}>
            <span className="material-icons">chevron_left</span>
          </div>
        </div>
        <div className="col col-center">
          <span>{format(currentMonth, dateFormat)}</span>
        </div>
        <div className="col col-end" onClick={nextMonth}>
          <div className="icon">
            <span className="material-icons">chevron_right</span>
          </div>
        </div>
      </div>
    );
  };

  const renderDays = () => {
    const dateFormat = 'EEEE';
    const days = [];
    let startDate = startOfWeek(currentMonth);
    for (let i = 0; i < 7; i++) {
      days.push(
        <div className="col col-center" key={i}>
          {format(addDays(startDate, i), dateFormat)}
        </div>
      );
    }
    return <div className="days row">{days}</div>;
  };

  const renderCells = () => {
    const monthStart = startOfMonth(currentMonth);
    const monthEnd = endOfMonth(monthStart);
    const startDate = startOfWeek(monthStart);
    const endDate = endOfWeek(monthEnd);
    const dateFormat = 'd';
    const rows = [];
    let days = [];
    let day = startDate;
    let formattedDate = '';
    while (day <= endDate) {
      for (let i = 0; i < 7; i++) {
        formattedDate = format(day, dateFormat);
        const cloneDay = day;
        const dailyEvents = events.filter((e) => isSameDay(e.date, cloneDay));
        days.push(
          <div
            className={`col cell ${!isSameMonth(day, monthStart)
                ? 'disabled'
                : isSameDay(day, new Date())
                  ? 'selected'
                  : ''
              }`}
            key={day}
          >
            <span className="number">{formattedDate}</span>
            {dailyEvents.map((event, index) => (
              <span className="event" key={index}>
                {event.eventName}
              </span>
            ))}
          </div>
        );
        day = addDays(day, 1);
      }
      rows.push(
        <div className="row" key={day}>
          {days}
        </div>
      );
      days = [];
    }
    return <div className="body">{rows}</div>;
  };

  const nextMonth = () => {
    setCurrentMonth(addDays(currentMonth, 31));
  };

  const prevMonth = () => {
    setCurrentMonth(addDays(currentMonth, -31));
  };
 

  return (
    <>
      {permissionscontext.view ? (
        <>
          <div className="calendar">
            <div>{renderHeader()}</div>
            <div>{renderDays()}</div>
            <div>{renderCells()}</div>
          </div>
          {showFilter && (
            <MomListFilter
              appliedFilters={filters}
              show={showFilter}
              onHide={() => setShowFilter(false)}
              onApplyFilter={(filterData) => {
                setFilters(filterData);
                setShowFilter(false);
              }}
              onClear={() => {
                setFilters({});
                setShowFilter(false);
              }}
            />
          )}
        </>
      ) : (
        <Notauthorized />
      )}
    </>
  );
};

export default Calendar;
